import ApiConfig from "../api/config/api-config";
import {UpdateResult} from "../api/generated/lib-rest";
import {BannerApi} from "../api/generated/herds-banner";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

export interface IBannerService {
    get(): Promise<string>;
    update(banner: string): Promise<UpdateResult>;
}

class BannerServiceImpl implements IBannerService {
    constructor(private readonly banerApi: BannerApi) {
    }

    async get(): Promise<string> {
        return (await this.banerApi.get()).item.message;
    }

    async update(banner: string): Promise<UpdateResult> {
        return await this.banerApi.update({message: banner});
    }

}

const apiConfig = new ApiConfig();
const bannerApi = new BannerApi(apiConfig);
export const BannerService: IBannerService = new BannerServiceImpl(bannerApi);

export const useBanner = () => useQuery({
    queryKey: ['global', 'banner'],
    queryFn: async () => await BannerService.get(),
});

export const useUpdateBanner = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (banner: string) => await BannerService.update(banner),
        onSettled: async () => queryClient.invalidateQueries({queryKey: ['global', 'banner']})
    });

    return {
        get updateBanner() { return mutation.mutateAsync },
        get isPending() { return mutation.isPending },
    }
};